<ng-container *ngIf="view === 'shareable' && { status: entityAssetsShareable?.status || 'Off' } as vars">
  <hr class="big-rule bottom"/>
  <div>Share a web form with the {{ type }} so they can submit/edit assets.</div>
  <binary-share-toggle
    [type]="'profile'"
    [shareType]="shareTypes.entityAsset"
    [hideBottom]="!entityAssetsShareable"
    [shareableFormat]="'oneLine'"
    [shareCode]="entityAssetsShareable?.code || ''"
    [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
    [title]="'Resource Assets webpage for Adding / Editing'"
    [shareTitle]="'Your shareable webpage:'"
    [generatingCode]="generatingAssetsCode"
    [status]="vars.status"
    (toggle)="toggleAssetsShare()"
    (changeStatus)="changeAssetsShareStatus($event)"
  >
  <ng-container *ngIf="vars.status !== 'Off'" [ngTemplateOutlet]="assetToggles"></ng-container></binary-share-toggle>
  
</ng-container>
<ng-container *ngIf="view === 'actions' && { on: !!entity.showAssetsLinkInBrief && !!entityAssetsShareable && entityAssetsShareable.status !== 'Off' } as vars">
  <add-link-to-brief-wrapper
    style="margin-top: 10px; display: block;"
    [title]="'<strong>Include assets webform </strong>'"
    [toggleOn]="vars.on"
    [selected]="entityAssetsShareable?.status || 'Off'"
    (toggle)="updateShowEditAssetsLinkInBrief()"
    (toggleStatus)="changeAssetsShareStatus($event)"
  > <div class="body" *ngIf="!!vars.on" >
      <ng-container [ngTemplateOutlet]="assetToggles"></ng-container>
    </div>
  </add-link-to-brief-wrapper>
</ng-container>

<ng-template #assetToggles>
  <title-toggle-wrapper [title]="'Can add new assets'" [hideBottom]="true"  [toggleOn]="!!entityAssetsShareable?.addNew" (toggle)="toggleAddNewAssets()"></title-toggle-wrapper>
  <ng-container *ngIf="associatedAssetIds.length">
    <h5 style="margin-top: 10px;">WHICH ASSETS CAN BE SEEN AND EDITED</h5>
    <ng-container *ngFor="let id of associatedAssetIds; first as first">
      <title-toggle-wrapper [ngClass]="{ first: first }" *ngIf="assets[id] as asset" [hideBottom]="true" [toggleOn]="(entityAssetsShareable?.editableAssetIds || []).includes(id)" (toggle)="toggleAssetId(id)">
        <asset-card class="title-slot" [tryToShowAsLink]="true" [asset]="asset"></asset-card>
      </title-toggle-wrapper>
    </ng-container>
  </ng-container>
</ng-template>